/* eslint-disable no-useless-catch */

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-settings';

export const EntitySettingApi = {
  find: async () => {
    const url = `${pathname}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (key: string, body: any = {}) => {
    const url = `${pathname}/${key}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (body: any = {}) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findDisplaySetting: async () => {
    const url = `${pathname}/display`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
